import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';

import CustomModal from '../../../Components/Components/Modal';

const TournamentTutorial = React.memo(({ showTournamentTutorial, toggleShowTournamentTutorial }) => {
  const { t } = useTranslation('tournamentHelp');

  const data = t('data', { returnObjects: true });

  const renderItem = (item) => {
    return (
      <React.Fragment>
        {item.description &&
          item.description.split('\n\n').map((para, i) => (
            <p key={i}>{para}</p>
          ))
        }
        {item.list && (
          <ul>
            {item.list.map((li, i) => <li key={i}>{li}</li>)}
          </ul>
        )}
      </React.Fragment>
    );
  }

  return (
    <>
      <CustomModal
        isOpen={showTournamentTutorial}
        toggle={toggleShowTournamentTutorial}
        size="lg"
        addClassName="tournaments-tutorial-modal"
        title={t('title')}
        footer={<Button color="link" className="modal-footer-button" onClick={toggleShowTournamentTutorial}>{t('common:common.close')}</Button>}
        footerClose
        body={(
          <Row>
            <Col>
              <div
                className={`tournaments-tutorial-table-scrollarea-new tournaments-tutorial-table-body`}
                show={false}
                rightOffset={12}
                topOffset={0}
                bottomOffset={0}
              >
                <div>
                  <ol>
                    {data.map((group, groupIndex) => (
                      <React.Fragment key={`${groupIndex}`}>
                        {group.title && (
                          <p className="title">{groupIndex + 1}. {group.title}</p>
                        )}

                        {group.data.map((section, sectionIndex) => (
                          <React.Fragment key={`${groupIndex}-${sectionIndex}`}>
                            {renderItem(section)}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </ol>
                </div>
              </div>
            </Col>
          </Row>
    )}
      />

    </>
  );
});

TournamentTutorial.propTypes = {
  showTournamentTutorial: PropTypes.bool,
  toggleShowTournamentTutorial: PropTypes.func.isRequired,
};

TournamentTutorial.defaultProps = {
  showTournamentTutorial: false,
};

export default TournamentTutorial;
